import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}


export function setToken(token,roleToken) {
   Cookies.set(TokenKey, token)
   Cookies.set("TokenRole",roleToken)
   return Cookies.get()
}

export function getTokenRole() {
  return Cookies.get('TokenRole')
}

export function removeToken() {
  Cookies.remove(TokenKey)
  Cookies.remove("TokenRole")
}
